import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle>Video and Audio preferences</AppTitle>
}

const skin = era.skin('routes/settings/video-audio')

SettingsVideoAudioPage.displayName = 'SettingsVideoAudioPage'
export function SettingsVideoAudioPage(): JSX.Element {
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <ui.RenderSkin name='videoAudio' />
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
